document.addEventListener("DOMContentLoaded", function() {
    const swiper_text = new Swiper(".swiper_text", {
        direction: 'horizontal',
        slidesPerView: 1,
        allowTouchMove: false, // Disable dragging
        autoHeight: true, // Enable adaptive height
    });

    const swiper_main = new Swiper('.swiper_main', {
        direction: 'horizontal',
        slidesPerView: 1, // Set slidesPerView to 1
        centeredSlides: true, // Center the slides
        centeredSlidesBounds: true, // Make sure the last slide is fully displayed
        autoHeight: true, // Enable adaptive height
        navigation: {
            nextEl: ".swiper-button-nextss",
            prevEl: ".swiper-button-prevss",
        },
        thumbs: {
            swiper: swiper_text,
        },
        breakpoints: {
            426: {
                slidesPerView: 1,
            }
        }
    });
});
